// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { TABBAR_ITEM_TRANSITION } from '../../../constants/ui/tabbar';
import theme from '../../../styled-components/dark';

const SvgElement = styled.svg`
  ${({ $isActive, $hasCounter }) => {
    if ($isActive) {
      if ($hasCounter) {
        return css`
          --cropped-circle-path-fill: ${theme.TabBar.Button.default.active.color};
          --cropped-circle-border-path-fill: ${theme.TabBar.Button.default.active.color};
          --player-icon-path-fill: transparent;
          --circle-path-fill: transparent;
          --circle-border-path-fill: transparent;
        `;
      }
      return css`
        --cropped-circle-path-fill: transparent;
        --cropped-circle-border-path-fill: transparent;
        --player-icon-path-fill: transparent;
        --circle-path-fill: ${theme.TabBar.Button.default.active.color};
        --circle-border-path-fill: ${theme.TabBar.Button.default.active.color};
      `;
    }

    if ($hasCounter) {
      return css`
        --cropped-circle-path-fill: transparent;
        --cropped-circle-border-path-fill: ${theme.TabBar.Button.default.passive.color};
        --player-icon-path-fill: ${theme.TabBar.Button.default.passive.color};
        --circle-path-fill: transparent;
        --circle-border-path-fill: transparent;
      `;
    }

    return css`
      --cropped-circle-path-fill: transparent;
      --cropped-circle-border-path-fill: transparent;
      --player-icon-path-fill: ${theme.TabBar.Button.default.passive.color};
      --circle-path-fill: transparent;
      --circle-border-path-fill: ${theme.TabBar.Button.default.passive.color};
    `;
  }}
`;

const sharedPathTransition = css`
  transition: fill ${TABBAR_ITEM_TRANSITION}ms ease-in-out;
`;

const CroppedCirclePath = styled.path`
  ${sharedPathTransition}
  fill: var(--cropped-circle-path-fill, transparent);
`;

const CroppedCircleBorderPath = styled.path`
  ${sharedPathTransition}
  fill: var(--cropped-circle-border-path-fill, transparent);
`;

const CirclePath = styled.path`
  ${sharedPathTransition}
  fill: var(--circle-path-fill, transparent);
`;

const CircleBorderPath = styled.path`
  ${sharedPathTransition}
  fill: var(--circle-border-path-fill, transparent);
`;

const PlayIconPath = styled.path`
  ${sharedPathTransition}
  fill: var(--player-icon-path-fill, transparent);
`;

type LiveIconSvgAsComponentProps = {
  isActive?: boolean;
  className?: string;
  hasCounter?: boolean;
};

const LiveIconSvgAsComponent = ({ className, isActive = false, hasCounter = false }: LiveIconSvgAsComponentProps) => {
  return (
    <SvgElement
      className={className}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      $isActive={isActive}
      $hasCounter={hasCounter}
    >
      <CroppedCirclePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5206 4.34247C18.868 3.48468 16.9906 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27C20.3117 27 24.8174 23.5488 26.397 18.7664C22.1623 17.8095 19 14.024 19 9.5C19 7.59865 19.5586 5.82776 20.5206 4.34247ZM12.9309 11.7334C12.9309 10.8772 13.937 10.4169 14.5848 10.9768L18.6517 14.4914C19.1132 14.8903 19.1132 15.6058 18.6517 16.0047L14.5848 19.5193C13.937 20.0792 12.9309 19.6189 12.9309 18.7627V11.7334Z"
      />
      <CroppedCircleBorderPath d="M26.397 18.7664C24.8174 23.5488 20.3117 27 15 27C8.37258 27 3 21.6274 3 15C3 8.37258 8.37258 3 15 3C16.9906 3 18.868 3.48468 20.5206 4.34247C20.1596 4.89981 19.8554 5.49736 19.6162 6.12693C18.2353 5.40699 16.6652 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25C19.433 25 23.1923 22.1155 24.5034 18.1209C25.1033 18.3995 25.7371 18.6173 26.397 18.7664Z" />
      <CirclePath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27ZM14.5848 10.9768C13.937 10.4169 12.9309 10.8772 12.9309 11.7334V18.7627C12.9309 19.6189 13.937 20.0792 14.5848 19.5193L18.6517 16.0047C19.1132 15.6058 19.1132 14.8903 18.6517 14.4914L14.5848 10.9768Z"
      />
      <CircleBorderPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25ZM15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27Z"
      />
      <PlayIconPath d="M12.9309 11.7334C12.9309 10.8772 13.937 10.4169 14.5848 10.9768L18.6517 14.4914C19.1132 14.8903 19.1132 15.6058 18.6517 16.0047L14.5848 19.5193C13.937 20.0792 12.9309 19.6189 12.9309 18.7627V11.7334Z" />
    </SvgElement>
  );
};

export default LiveIconSvgAsComponent;
